import React, { useState } from "react";

import {
  FaInfoCircle,
  FaCalendarAlt,
  FaChevronDown,
  
  FaUser,
  FaCheck,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaShieldAlt,
  FaFileInvoice,
  FaFileMedical,
  FaIdCard,
  FaFileAlt,
  FaRedo,
  FaPaperPlane,
  FaHeadset,
  FaEye,
} from "react-icons/fa";

import "./Claims.css";

function Claims() {
  const [formData, setFormData] = useState({
    claimType: "",
    incidentDate: "",
    incidentPlace: "",
    description: "",
    estimatedAmount: "",
    hospitalName: "",
  });

  const [documents, setDocuments] = useState({
    bills: null,
    medical: null,
    idProof: null,
    other: null,
  });

  const [submitted, setSubmitted] = useState(false);

  const member = {
    name: "Ramesh Babu",
    memberId: "APNBM240520001",
    mobile: "+91 91234 56789",
    validTill: "19 May 2025",
    status: "Active Member",
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleFileChange = (event, documentType) => {
    const file = event.target.files[0];

    setDocuments((previous) => ({
      ...previous,
      [documentType]: file || null,
    }));
  };

  const resetForm = () => {
    setFormData({
      claimType: "",
      incidentDate: "",
      incidentPlace: "",
      description: "",
      estimatedAmount: "",
      hospitalName: "",
    });

    setDocuments({
      bills: null,
      medical: null,
      idProof: null,
      other: null,
    });

    setSubmitted(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setSubmitted(true);

    console.log("Claim Data:", formData);
    console.log("Documents:", documents);
  };

  return (
    <div className="claims-page">

      {/* =====================================================
          PAGE HEADER
      ===================================================== */}

      <div className="claims-breadcrumb">
        <span>Home</span>
        <span className="breadcrumb-arrow">›</span>
        <span>Claims</span>
        <span className="breadcrumb-arrow">›</span>
        <span>Submit a Claim</span>
      </div>

      <div className="claims-layout">

        {/* ===================================================
            LEFT MAIN CONTENT
        =================================================== */}

        <div className="claims-main-content">

          <h1 className="claims-page-title">
            Submit a Claim
          </h1>


          {/* INFORMATION MESSAGE */}

          <div className="claims-info-banner">

            <FaInfoCircle />

            <span>
              Please fill in the claim details below and upload
              the required documents. Our team will verify and
              process your claim.
            </span>

          </div>


          {/* =================================================
              CLAIM FORM CARD
          ================================================= */}

          <form
            className="claim-form-card"
            onSubmit={handleSubmit}
          >

            {/* -----------------------------------------------
                SECTION 1
            ----------------------------------------------- */}

            <div className="claim-section">

              <h2 className="claim-section-title">
                1. Claim Information
              </h2>


              <div className="claim-fields-grid">

                {/* CLAIM TYPE */}

                <div className="claim-field">

                  <label htmlFor="claimType">
                    Claim Type
                    <span className="required">*</span>
                  </label>

                  <div className="select-wrapper">

                    <select
                      id="claimType"
                      name="claimType"
                      value={formData.claimType}
                      onChange={handleInputChange}
                      required
                    >

                      <option value="">
                        Select Claim Type
                      </option>

                      <option value="medical">
                        Medical Claim
                      </option>

                      <option value="hospitalization">
                        Hospitalization Claim
                      </option>

                      <option value="accident">
                        Accident Claim
                      </option>

                      <option value="death">
                        Death Claim
                      </option>

                      <option value="other">
                        Other Claim
                      </option>

                    </select>

                    <FaChevronDown />

                  </div>

                </div>


                {/* DATE */}

                <div className="claim-field">

                  <label htmlFor="incidentDate">
                    Date of Incident
                    <span className="required">*</span>
                  </label>

                  <div className="claim-input-icon">

                    <input
                      id="incidentDate"
                      name="incidentDate"
                      type="date"
                      value={formData.incidentDate}
                      onChange={handleInputChange}
                      required
                    />

                    <FaCalendarAlt />

                  </div>

                </div>


                {/* PLACE */}

                <div className="claim-field">

                  <label htmlFor="incidentPlace">
                    Place of Incident
                    <span className="required">*</span>
                  </label>

                  <input
                    id="incidentPlace"
                    name="incidentPlace"
                    type="text"
                    placeholder="Enter place of incident"
                    value={formData.incidentPlace}
                    onChange={handleInputChange}
                    required
                  />

                </div>


                {/* DESCRIPTION */}

                <div className="claim-field claim-field-full">

                  <label htmlFor="description">
                    Brief Description
                    <span className="required">*</span>
                  </label>

                  <div className="textarea-wrapper">

                    <textarea
                      id="description"
                      name="description"
                      maxLength="500"
                      placeholder="Please provide a brief description of the incident and reason for claim"
                      value={formData.description}
                      onChange={handleInputChange}
                      required
                    />

                    <span>
                      {formData.description.length}/500
                    </span>

                  </div>

                </div>


                {/* AMOUNT */}

                <div className="claim-field">

                  <label htmlFor="estimatedAmount">
                    Estimated Claim Amount (₹)
                    <span className="required">*</span>
                  </label>

                  <input
                    id="estimatedAmount"
                    name="estimatedAmount"
                    type="number"
                    min="0"
                    placeholder="Enter amount"
                    value={formData.estimatedAmount}
                    onChange={handleInputChange}
                    required
                  />

                </div>


                {/* HOSPITAL */}

                <div className="claim-field">

                  <label htmlFor="hospitalName">
                    Hospital / Service Provider Name
                  </label>

                  <input
                    id="hospitalName"
                    name="hospitalName"
                    type="text"
                    placeholder="Enter hospital / provider name"
                    value={formData.hospitalName}
                    onChange={handleInputChange}
                  />

                </div>

              </div>

            </div>


            {/* =================================================
                SECTION 2 MEMBER INFORMATION
            ================================================= */}

            <div className="claim-section">

              <h2 className="claim-section-title">

                2. Member Information

                <span className="auto-filled">
                  (Auto Filled)
                </span>

              </h2>


              <div className="member-auto-card">

                <div className="member-auto-icon">
                  <FaUser />
                </div>


                <div className="member-auto-details">

                  <div className="member-name-row">

                    <strong>
                      {member.name}
                    </strong>

                    <span className="member-active">
                      {member.status}
                    </span>

                  </div>


                  <div className="member-details-line">

                    <span>
                      Member ID:
                      <strong>
                        {member.memberId}
                      </strong>
                    </span>

                    <span className="detail-separator">
                      |
                    </span>

                    <span>
                      Mobile:
                      <strong>
                        {member.mobile}
                      </strong>
                    </span>

                  </div>


                  <div className="member-validity">
                    Membership Valid Till:
                    <strong>
                      {member.validTill}
                    </strong>
                  </div>

                </div>


                <button
                  type="button"
                  className="view-profile-button"
                >
                  <FaEye />
                  View Profile
                </button>

              </div>

            </div>


            {/* =================================================
                SECTION 3 DOCUMENTS
            ================================================= */}

            <div className="claim-section">

              <h2 className="claim-section-title">
                3. Upload Documents
              </h2>

              <p className="upload-description">
                Please upload clear and valid documents for faster
                claim processing.
              </p>


              <div className="documents-grid">

                <DocumentCard
                  title="Bills / Invoices"
                  required={true}
                  icon={<FaFileInvoice />}
                  file={documents.bills}
                  onChange={(event) =>
                    handleFileChange(event, "bills")
                  }
                />


                <DocumentCard
                  title="Reports / Prescription"
                  required={true}
                  icon={<FaFileMedical />}
                  file={documents.medical}
                  onChange={(event) =>
                    handleFileChange(event, "medical")
                  }
                />


                <DocumentCard
                  title="ID Proof (if required)"
                  required={false}
                  icon={<FaIdCard />}
                  file={documents.idProof}
                  onChange={(event) =>
                    handleFileChange(event, "idProof")
                  }
                />


                <DocumentCard
                  title="Other Documents"
                  required={false}
                  icon={<FaFileAlt />}
                  file={documents.other}
                  onChange={(event) =>
                    handleFileChange(event, "other")
                  }
                />

              </div>

            </div>


            {/* =================================================
                FORM ACTIONS
            ================================================= */}

            <div className="claim-actions">

              <button
                type="button"
                className="claim-reset-button"
                onClick={resetForm}
              >

                <FaRedo />

                Reset

              </button>


              <button
                type="submit"
                className="claim-submit-button"
              >

                <FaPaperPlane />

                Submit Claim

              </button>

            </div>


            {submitted && (

              <div className="claim-submitted-message">

                <FaCheckCircle />

                <div>

                  <strong>
                    Claim submitted successfully.
                  </strong>

                  <p>
                    Your claim has been received and will be
                    reviewed by our team.
                  </p>

                </div>

              </div>

            )}

          </form>

        </div>


        {/* ===================================================
            RIGHT SIDEBAR
        =================================================== */}

        <aside className="claims-right-sidebar">


          {/* =================================================
              CLAIM PROCESS
          ================================================= */}

          <div className="claims-side-card">

            <h3>
              Claim Process Steps
            </h3>


            <div className="claim-process">

              <ProcessStep
                number="1"
                color="blue"
                title="Submit Claim"
                description="Fill claim form and upload documents"
              />

              <ProcessStep
                number="2"
                color="purple"
                title="Verification"
                description="Our team will verify your claim"
              />

              <ProcessStep
                number="3"
                color="orange"
                title="Processing"
                description="Claim will be processed"
              />

              <ProcessStep
                number="4"
                color="green"
                title="Approval & Settlement"
                description="Amount will be settled"
                last
              />

            </div>

          </div>


          {/* =================================================
              REQUIRED DOCUMENTS
          ================================================= */}

          <div className="claims-side-card">

            <h3>
              Required Documents
            </h3>


            <ul className="required-documents">

              <li>
                Bills / Invoices
              </li>

              <li>
                Medical Reports / Prescription
              </li>

              <li>
                ID Proof (if required)
              </li>

              <li>
                Any other supporting documents
              </li>

            </ul>


            <div className="documents-success-note">

              <FaShieldAlt />

              <span>
                Ensure all documents are clear and readable.
              </span>

            </div>

          </div>


          {/* =================================================
              NEED ASSISTANCE
          ================================================= */}

          <div className="claims-side-card assistance-card">

            <h3>
              Need Assistance?
            </h3>

            <p className="assistance-text">
              Our support team is here to help you.
            </p>


            <div className="support-contact">

              <div>
                <FaPhone />
                <span>
                  +91 91234 56789
                </span>
              </div>


              <div>
                <FaEnvelope />
                <span>
                  support@apnbtrust.org
                </span>
              </div>


              <div>
                <FaClock />
                <span>
                  Mon - Sat: 9:00 AM - 6:00 PM
                </span>
              </div>

            </div>


            <button
              type="button"
              className="support-ticket-button"
            >

              <FaHeadset />

              RAISE SUPPORT TICKET

            </button>

          </div>

        </aside>

      </div>

    </div>
  );
}


/* ==========================================================
   DOCUMENT CARD
========================================================== */

function DocumentCard({
  title,
  required,
  icon,
  file,
  onChange,
}) {
  return (
    <div className="document-card">

      <h4>
        {title}

        {required && (
          <span className="required">
            *
          </span>
        )}

      </h4>


      <div className="document-upload-circle">
        {icon}
      </div>


      <label className="document-upload-button">

        {file ? "Change File" : "Upload File"}

        <input
          type="file"
          accept=".pdf,.jpg,.jpeg,.png"
          onChange={onChange}
          hidden
        />

      </label>


      <p>
        {file
          ? file.name
          : "PDF, JPG, PNG (Max 5MB)"}
      </p>

    </div>
  );
}


/* ==========================================================
   PROCESS STEP
========================================================== */

function ProcessStep({
  number,
  color,
  title,
  description,
  last,
}) {
  return (
    <div
      className={`process-step process-${color} ${
        last ? "process-last" : ""
      }`}
    >

      <div className="process-number">
        {number}
      </div>


      <div className="process-content">

        <strong>
          {title}
        </strong>

        <span>
          {description}
        </span>

      </div>

    </div>
  );
}


/* ==========================================================
   ICON
========================================================== */

function FaCheckCircle() {
  return <FaCheck />;
}


export default Claims;